module.exports = "<p>\n  unify-marketing-details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing-details/unify-marketing-details.component.html
// module id = ./src/app/prospect/unify-marketing-details/unify-marketing-details.component.html
// module chunks = main